/**
 * RobiInfoModal — shown when a member without an AI Buddy taps the Post Buddy
 * icon on their own post. Introduces the feature and routes them to choose one.
 *
 * Mobile parity difference: mobile only shows a toast error here. Web adds an
 * informational modal with a call-to-action, per the product spec.
 */
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { RobiIcon } from '../../components/ui/icons';
import './feedModal.css';

interface RobiInfoModalProps {
  onClose: () => void;
}

export function RobiInfoModal({ onClose }: RobiInfoModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleChoose = () => {
    onClose();
    navigate('/choose-ai-buddy');
  };

  return (
    <Modal
      title={t('home.feed.postBuddy.noBuddyTitle')}
      labelledBy="robi-info-title"
      onClose={onClose}
      className="feed-prompt-modal"
    >
      <div className="feed-prompt">
        <span className="feed-prompt__media feed-prompt__media--alert" aria-hidden>
          <RobiIcon size={48} />
        </span>
        <div className="feed-prompt__copy">
          <p className="feed-prompt__title" aria-hidden="true">
            {t('home.feed.postBuddy.noBuddyTitle')}
          </p>
          <p className="feed-prompt__message">
            {t('home.feed.postBuddy.noBuddyDescription')}
          </p>
        </div>
        <div className="feed-prompt__actions">
          <Button variant="ghost" fullWidth onClick={onClose}>
            {t('common.buttons.cancel')}
          </Button>
          <Button fullWidth onClick={handleChoose}>
            {t('home.feed.postBuddy.noBuddyCta')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
